import { alpha } from '@mui/system'
import styled from 'styled-components'
import colors from 'styles/colors'

const StyledAudioPlayer = styled.div`
  .rhap_container {
    padding: 0;
  }

  .rhap_progress-section {
    .rhap_progress-container {
      margin: 0;
    }
    &:hover {
      .rhap_progress-indicator {
        display: block;
      }
    }
    .rhap_progress-bar {
      height: 6px;
      background: ${colors.MidnightTeal300};
      border-radius: 5px;
    }
    .rhap_download-progress {
      background-color: ${alpha(colors.MutedTeal100, 0.1)};
    }
  }

  .rhap_volume-bar {
    height: 6px;
    background: ${colors.MidnightTeal300};
    border-radius: 5px;
  }

  .rhap_volume-bar-area {
    z-index: 1;
    &:hover {
      .rhap_volume-indicator {
        display: block;
      }
    }
  }

  .rhap_progress-filled,
  .rhap_volume-filled {
    background-color: ${colors.White};
    border-radius: 5px;
  }

  .rhap_progress-indicator,
  .rhap_volume-indicator {
    display: none;
    background-color: ${colors.White};
    border-radius: 5px;
  }

  .rhap_main-controls {
    gap: 24px;
    flex: 0;
  }

  .rhap_main-controls button {
    color: ${colors.Grey};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    svg {
      font-size: 32px;
    }
  }

  .rhap_main-controls button.rhap_play-pause-button {
    width: 48px;
    height: 48px;
    color: ${colors.Grey};
    svg {
      font-size: 48px;
    }
  }

  .rhap_volume-container {
    flex: 0 1 140px;
    flex-direction: row-reverse;
    gap: 8px;
  }
`

export default StyledAudioPlayer
